main {
	/* Dimensions */
	height: 100%;

	/* Flex */
	display: flex;
	flex-direction: column;
}

section {
	/* Flex */
	flex-grow: 1;
	display: flex;

	/* Overflow */
	overflow-y: auto;
	overflow-x: hidden;
}

#contentWrapper {
	/* Position */
	position: relative;

	/* Flex */
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	
	/* Overflow */
	overflow-y: auto;

	/* Spacing */
	padding: 14px;
}

::slotted(div[slot="content"]) {
	/* Flex */
	flex-grow: 1;
	
	/* Color */
	background-color: var(--card-color);

	/* Border */
	border-radius: 5px;
	box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
}